import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ClearanceItem } from '../clearance-item.model';
import { MaterializeAction } from 'angular2-materialize';
import { PENDING_STATUSES } from '../../shared/helper-components/constants';

@Component({
    selector: 'bulk-bar',
    template:require('./clearance-item-bulkbar.component.html'),
    styles: [`
        .anchor{
            margin-right: 0px !important;
        }
    `]
})
export class ClearanceItemBulkBarComponent{

    @Input()
    itemList: ClearanceItem[] = [];
    @Input()
    public isClearanceUser: boolean;
    @Input()
    public projectId: string;
    @Output()
    ModalInitializationRequested: EventEmitter<string> = new EventEmitter<string>();
    @Output()
    downloadImagesRequested: EventEmitter<void> = new EventEmitter<void>();
    @Input()
    backActionVisible: boolean;
    @Input()
    downloadButtonVisible: boolean = true;
    @Input()
    readOnly: boolean = false;


    anyItemSelected(): boolean {
        return this.itemList && this.itemList.filter(it => it.isSelected).length > 0;
    }

    get tagsCanBeEdited(): boolean {
        let selectedItems = this.itemList.filter(it => it.isSelected);

        return selectedItems.length > 0 && (this.isClearanceUser || selectedItems.every(it => PENDING_STATUSES.has(it.status.toUpperCase())));
    }

    initializeModal(modalId: string){
        this.ModalInitializationRequested.next(modalId);
    }

    enableStatusUpdateBatch(): boolean {
        let isSelected = this.itemList && this.itemList.filter(it => it.isSelected).length > 0 && this.isClearanceUser;
        return isSelected;
    }

    cancel(){
        this.itemList.forEach(i=> {
            i.isSelected = false;
        });
    }

    downloadImages(){
        this.downloadImagesRequested.emit();
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/bulk-action/clearance-item-bulkbar.component.ts